export const AreaTypes = {
    SET_AREATYPES: "SET_AREATYPES",
    SELECTED_AREATYPE: "SELECTED_AREATYPE",
    GET_AllAreaIdUser: "GET_AllQRCodeIdUser",
    ADD_AREATYPE: "ADD_AREATYPE",
    UPDATE_AREATYPE: "UPDATE_AREATYPE",
    DELETE_SELECTED_AREATYPE: "DELETE_SELECTED_AREATYPE",
}